/**
 * @generated SignedSource<<594701706132dd69db4403534c69dbb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProfileDisplayType = "BASIC" | "BLOG" | "RESOURCE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type WorkTab_userProfile$data = {
  readonly analyticsId: number;
  readonly displayUsername: string;
  readonly profileDisplayType: ProfileDisplayType;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "WorkTab_userProfile";
};
export type WorkTab_userProfile$key = {
  readonly " $data"?: WorkTab_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkTab_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkTab_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileDisplayType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "d5e09d56fd9ea2325ef78664a19db165";

export default node;
